export const displayGoingToCloseParkingSelector = ({displayGoingToCloseParking}) => displayGoingToCloseParking